<div class="header">
  @if (setEnv) {
    <span class="env">ENV: {{setEnv}}</span>
  }
  <img src="assets/images/nsf_logo.svg" alt="NSF Logo">  
  <span>Certified Products and Systems</span>
  <p>Search for companies whose products and systems have been certified by NSF.</p>
</div>
